<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>
<style lang="less" scoped>
  /*#app{*/
  /*  width: 100vw;*/
  /*  min-width:1140px;*/
  /*  min-height: 400px;*/
  /*}*/
</style>

<style  lang="less">
  .el-loading-spinner .circular{
    width: 42px;
    height: 42px;
    animation: loading-rotate 2s linear infinite;
    display: none;
  }
  .el-loading-spinner{
    /* 图片替换为你自定义的即可 */
    background: url(./assets/images/loading.gif) no-repeat;
    background-size: 200px 200px;
    width: 200px !important;
    height: 200px;
    position: relative;
    top: 50%;
    left: 50%;
    margin-top: -100px !important;
    margin-left: -100px;
  }
</style>
